import { useRef, useState } from "react";
import "./Register.css"
import Map from "../../components/Map/Map";
import { Link, useLocation } from "wouter";
import axios from "axios";
import { api } from "../../settings/env";
import { convert64 } from "../../utils/images_manager";

export function Register() {

    const [step, setStep] = useState(1);
    const [typeForm, setTypeForm] = useState("");
    const [categoryForm, setCategoryForm] = useState("");

    const [timeFrom, setTimeFrom] = useState("");
    const [timeTo, setTimeTo] = useState("");

    /** Data form */
    const [fullname, setFullname] = useState("");
    const [profile, setProfile] = useState("https://img.freepik.com/foto-gratis/fondo-abstracto-textura_1258-30553.jpg?semt=ais_hybrid");

    // Personal
    const [name, setName] = useState("");
    const [lastname, setLastname] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [terms, setTerms] = useState(false);

    //
    const [dni, setDni] = useState("");
    const [address, setAddress] = useState("");
    const [phone, setPhone] = useState("");

    // Professional
    const [domicilio, setDomicilio] = useState("false");
    const [transporteSanitario, setTransporteSanitario] = useState("false");
    const [efectivo, setEfectivo] = useState(false);
    const [pagoMovil, setPagoMovil] = useState(false);
    const [delivery, setDelivery] = useState("false");
    const imgProfileRef = useRef();
    const [navigation, setNavigation] = useLocation()

    // Location
    const [location, setLocation] = useState({ lat: 0, lng: 0 });

    const handleLocation = (location) => {
        setLocation(location);
    }

    const typeFormHandle = (value) => {
        setTypeForm(value);
    }

    const handleForm = (value) => {
        setCategoryForm(value);
        setStep(2);
    };

    const changeImageProfile = (value) => {
        convert64(value);
    };

    const clickMap = (value) => {
        setLocation(value);
    }

    const deliveryHandle = (e) => {
        console.log(e.target.value);
        setDelivery(e.target.value);
    };

    const transporteSanitarioHandle = (e) => {
        console.log(e.target.value);
        setTransporteSanitario(e.target.value);
    };

    const domicilioHandle = (e) => {
        console.log(e.target.value);
        setDomicilio(e.target.value);
    };


    const registerProfessional = () => {
        const data = {
            "fullName": `${fullname}`,
            "mail": email,
            "password": password,
            "profilePicture": profile,
            "imageGallery": [],
            "description": "",
            "type": categoryForm,
            "openingHours": {
                form: timeFrom,
                to: timeTo
            },
            "location": location,
            "yearsOfExperience": 0,
            "paymentMethods": {
                "efectivo": efectivo,
                "movil": pagoMovil,
            },
            "delivery": JSON.parse(delivery),
            "medicalTransport": JSON.parse(transporteSanitario),
            "titled": false,
            "titleImage": ""
        }

        axios.post(`${api}/register`, data)
            .then(response => {
                if (response.data.success) {
                    console.log("Usuario registrado exitosamente", response.data);
                    alert("Registro exitoso");
                    setNavigation("/login");
                } else {
                    console.log("Error al registrar el usuario", response.data);
                    alert("Error al registrar el usuario");
                }
            })
            .catch(error => {
                console.error(error);
                alert("Error al registrar el usuario");

            });
    };

    const registerPersonal = () => {
        // TODO: Implementar la lógica para el registro de un usuario personal
        console.log("Registro personal", name, lastname, email, password, confirmPassword);

        // TODO: Validar contraseña
        if (password !== confirmPassword) {
            alert("Las contraseñas no coinciden");
            return;
        }

        // TODO: Validar email y contraseña

        // TODO: Registrar usuario personal en la base de datos
        const data = {
            "fullName": `${name} ${lastname}`,
            "mail": email,
            "password": password,
            "profilePicture": profile,
            "imageGallery": [],
            "description": "",
            "type": "personal",
            "openingHours": {},
            "location": "Caracas",
            "yearsOfExperience": 0,
            "paymentMethods": {},
            "delivery": false,
            "medicalTransport": false,
            "titled": false,
            "titleImage": ""
        }

        axios.post(`${api}/register`, data)
            .then(response => {
                if (response.data.success) {
                    console.log("Usuario registrado exitosamente", response.data);
                    alert("Registro exitoso");
                    // TODO: Redireccionar al login
                    setNavigation("/login");
                }
                // TODO: Redireccionar al login
            })
            .catch(error => {
                console.error("Error al registrar", error);
                alert("Error al registrar");
            });

        // TODO: Enviar correo de confirmación

        //alert("Registro exitoso");
        // TODO: Redireccionar al login
    }

    const handleImage = async (e) => {
        try {
            const management_image = await convert64(e);

            console.log("MANAGEMENT IMAGE", management_image);

            if (management_image && management_image !== null) {
                console.log("Entró en true");
                setProfile(management_image); // Aquí puedes guardar la imagen convertida
            } else {
                console.log("Reseteando el input debido a un error");
                imgProfileRef.current.value = ""; // Reinicia el campo de entrada
                alert("Hubo un problema con la imagen. Por favor, intenta con otro archivo.");
            }
        } catch (error) {
            console.error("Error al manejar la imagen:", error);
            imgProfileRef.current.value = ""; // Reinicia el campo si ocurre un error
            alert("Ocurrió un error al procesar la imagen. Por favor, inténtalo nuevamente.");
        }
    };


    return (
        <div className="register">
            <div className="form-register">


                <form onSubmit={(e) => {
                    e.preventDefault();
                }}>
                    <div className="logo">
                        <Link to="/">
                            <img src="/assets/vitaly.webp" alt="" />
                        </Link>
                    </div>

                    {
                        step == 1 && typeForm == "" &&
                        <div class="mb-3">
                            <h2 class="form-label text-center">
                                <b>¡Crea una cuenta!</b>
                            </h2>
                            <p className="text-center subtitle-register">
                                Puedes elegir entre dos tipos de cuenta
                            </p>
                            <br />


                            <div className="card-grid">
                                <div className="card-user">
                                    <img src="https://img.freepik.com/foto-gratis/fondo-abstracto-textura_1258-30553.jpg?semt=ais_hybrid" alt="" />

                                    <div className="content">
                                        <h3>Personal</h3>
                                        <p>Ofrece servicios y productos para la salud</p>
                                        <button
                                            className="btn btn-primary my-2 mx-2"
                                            style={{ fontSize: "13px" }}
                                            onClick={() => typeFormHandle("user")}
                                        >
                                            ¡Regístrate ahora!
                                        </button>
                                    </div>
                                </div>

                                <div className="card-user">
                                    <img src="https://img.freepik.com/foto-gratis/fondo-abstracto-textura_1258-30553.jpg?semt=ais_hybrid" alt="" />

                                    <div className="content">
                                        <h3>Empresarial</h3>
                                        <p>Ofrece servicios y productos para la salud</p>
                                        <button
                                            className="btn btn-primary my-2 mx-2"
                                            style={{ fontSize: "13px" }}
                                            onClick={() => typeFormHandle("profesional")}
                                        >
                                            ¡Regístrate ahora!
                                        </button>
                                    </div>
                                </div>
                            </div>






                            {/* <div id="emailHelp" class="form-text">We'll never share your email with anyone else.</div> */}
                        </div>
                    }

                    {
                        step == 1 && typeForm == "user" &&
                        <div>
                            <h2 className="text-center">
                                ¡Crea una cuenta personal!
                            </h2>

                            <p className="subtitle text-center">
                                ¿Ya tienes cuenta? <Link to="login">¡Inicia Sesion!</Link>
                            </p>

                            <div className="form-personal">


                                <div>
                                    <div className="box-profile">
                                        <img src={profile} alt="" />
                                    </div>
                                    <label>Foto de perfil</label> <br />
                                    <input type="file" ref={imgProfileRef} onChange={changeImageProfile} placeholder="File" />

                                </div>

                                <div className="input-two">
                                    <input type="text" placeholder="Nombre" onKeyUp={(e) => setName(e.target.value)} />
                                    <input type="text" placeholder="Apellido" onKeyUp={(e) => setLastname(e.target.value)} />
                                </div>


                                <input type="text" placeholder="Email" onKeyUp={(e) => setEmail(e.target.value)} />
                                <input type="password" placeholder="Contraseña" onKeyUp={(e) => setPassword(e.target.value)} />
                                <input type="password" placeholder="Repetir contraseña" onKeyUp={(e) => setConfirmPassword(e.target.value)} />

                                <div className="condiciones">
                                    <input type="checkbox" />
                                    <span>Acepto terminos y condiciones</span>
                                </div>

                                <button className="btn btn-primary" onClick={registerPersonal}>
                                    Crea tu Cuenta
                                </button>
                            </div>
                        </div>
                    }

                    {
                        step == 1 && typeForm == "profesional" &&
                        <div class="mb-3 box-categories">
                            <div className="steps text-center mb-4">
                                <span>Paso {step} de 2</span>
                            </div>
                            <label for="exampleInputEmail1" class="form-label">Seleciona tu categoria</label>
                            <br />

                            <button
                                className="btn btn-primary my-2 mx-2"
                                onClick={() => handleForm("Profesional titulado")}
                            >
                                Profesional titulado
                            </button>

                            <button
                                className="btn btn-primary my-2 mx-2"
                                onClick={() => handleForm("Profesional no titulado")}
                            >
                                Profesional no titulado
                            </button>

                            <button className="btn btn-primary my-2 mx-2"
                                onClick={() => handleForm("Centro de Radiologia e imagen")}
                            >
                                Centro de Radiologia e imagen
                            </button>

                            <button className="btn btn-primary my-2 mx-2"
                                onClick={() => handleForm("Hospital y clinica")}
                            >
                                Hospital y clinica
                            </button>

                            <button className="btn btn-primary my-2 mx-2"
                                onClick={() => handleForm("Laboratorio")}
                            >
                                Laboratorio
                            </button>

                            <button className="btn btn-primary my-2 mx-2"
                                onClick={() => handleForm("Farmacia")}
                            >
                                Farmacia
                            </button>

                            <button className="btn btn-primary my-2 mx-2"
                                onClick={() => handleForm("Material medico")}
                            >
                                Material medico
                            </button>
                            {/* <div id="emailHelp" class="form-text">We'll never share your email with anyone else.</div> */}
                        </div>
                    }

                    {
                        step == 2 && <>

                            <div className="steps text-center mb-4">
                                <span>Paso {step} de 2</span>
                            </div>

                            <div className="form-personal" style={{width: "420px"}}>

                                <div class="mb-3">
                                    <label class="form-label">Nombre completo</label>
                                    <input type="text" class="form-control" onKeyUp={(e) => setFullname(e.target.value)} />
                                    {/* <div id="emailHelp" class="form-text">We'll never share your email with anyone else.</div> */}
                                </div>


                                <div class="mb-3">
                                    <label className="form-label">Correo electronico</label>
                                    <input type="email" class="form-control" onKeyUp={(e) => setEmail(e.target.value)} />
                                    {/* <div id="emailHelp" class="form-text">We'll never share your email with anyone else.</div> */}
                                </div>

                                <div class="mb-3">
                                    <label for="exampleInputPassword1" class="form-label">Contraseña</label>
                                    <input type="password" class="form-control" onKeyUp={(e) => setPassword(e.target.value)} />
                                </div>

                                <div class="mb-3">
                                    <label for="exampleInputPassword1" class="form-label">Confirmar contraseña</label>
                                    <input type="password" class="form-control" onKeyUp={(e) => setConfirmPassword(e.target.value)} />
                                </div>

                            </div>


                            <button class="btn btn-primary mt-4" onClick={() => setStep(1)}>
                                Regresar
                            </button>

                            <button class="btn btn-primary mx-4 mt-4"
                                onClick={() => setStep(3)}
                            >
                                Siguiente
                            </button>

                        </>

                    }

                    {
                        step == 3 && <>

                            <div className="steps text-center mb-4">
                                <span>Paso {step} de 2</span>
                            </div>

                            <div class="mb-3">
                                <label class="form-label">
                                    Horario de apertura
                                </label>

                                <br />

                                <div className="time-grid">
                                    <div>
                                        <span>Desde:</span>
                                        <input type="time" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                                    </div>

                                    <div>
                                        <span>Hasta:</span>
                                        <input type="time" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                                    </div>
                                </div>
                                {/* <div id="emailHelp" class="form-text">We'll never share your email with anyone else.</div> */}
                            </div>


                            <div className="mb-3">
                                <label htmlFor="exampleInputPassword1" className="form-label">
                                    Delivery
                                </label>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="delivery"
                                        checked={delivery === "true"} // Usar estricta comparación (===) en lugar de (==)
                                        value={"true"}
                                        onChange={deliveryHandle}
                                    />
                                    <label className="form-check-label" htmlFor="flexRadioDefault1">
                                        Sí
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="delivery"
                                        checked={delivery === "false"} // Usar estricta comparación (===)
                                        value={"false"}
                                        onChange={deliveryHandle}
                                    />
                                    <label className="form-check-label" htmlFor="flexRadioDefault2">
                                        No
                                    </label>
                                </div>
                            </div>


                            <div class="mb-3">
                                <label for="exampleInputPassword1" class="form-label">
                                    Métodos de pago
                                </label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" name="pagomovil" onChange={(e) => setPagoMovil(e.target.checked)} />
                                    <label class="form-check-label" for="flexRadioDefault1">
                                        Pago Movil
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" name="efectivo" onChange={(e) => setEfectivo(e.target.checked)} />
                                    <label class="form-check-label" for="flexRadioDefault2">
                                        Efectivo
                                    </label>
                                </div>
                            </div>

                            <button class="btn btn-primary mt-4" onClick={() => setStep(1)}>
                                Regresar
                            </button>

                            <button class="btn btn-primary mx-4 mt-4"
                                onClick={() => setStep(4)}
                            >
                                Siguiente
                            </button>

                        </>

                    }

                    {
                        step == 4 && <>

                            <div className="steps text-center mb-4">
                                <span>Paso {step} de 2</span>
                            </div>

                            <div class="mb-3">
                                <label for="exampleInputEmail1" class="form-label">Servicio a domicilio</label>

                                <div class="form-check">
                                    <input
                                        class="form-check-input"
                                        type="radio"
                                        name="domicilio"
                                        checked={domicilio === "true"}
                                        value={"true"}
                                        onChange={domicilioHandle}
                                    />
                                    <label class="form-check-label" for="flexRadioDefault1">
                                        Sí
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input
                                        class="form-check-input"
                                        type="radio"
                                        name="domicilio"
                                        checked={domicilio === "false"}
                                        value={"false"}
                                        onChange={domicilioHandle}
                                    />
                                    <label class="form-check-label" for="flexRadioDefault2">
                                        No
                                    </label>
                                </div>
                            </div>


                            <div class="mb-3">
                                <label for="exampleInputEmail1" class="form-label">Transporte sanitario</label>
                                <div class="form-check">
                                    <input
                                        class="form-check-input"
                                        type="radio"
                                        name="flexRadioDefault"
                                        checked={transporteSanitario === "true"}
                                        value={"true"}
                                        onChange={transporteSanitarioHandle}
                                    />
                                    <label class="form-check-label" for="flexRadioDefault1">
                                        Sí
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input
                                        class="form-check-input"
                                        type="radio"
                                        name="flexRadioDefault"
                                        checked={transporteSanitario === "false"}
                                        value={"false"}
                                        onChange={transporteSanitarioHandle}
                                    />
                                    <label class="form-check-label" for="flexRadioDefault2">
                                        No
                                    </label>
                                </div>
                            </div>

                            <button class="btn btn-primary mt-4" onClick={() => setStep(1)}>
                                Regresar
                            </button>

                            <button class="btn btn-primary mx-4 mt-4"
                                onClick={() => setStep(5)}
                            >
                                Siguiente
                            </button>

                        </>

                    }

                    {
                        step == 5 && <>

                            <div className="steps text-center mb-4">
                                <span>Paso {step} de 2</span>
                            </div>

                            <div class="mb-3">
                                <label
                                    class="form-label"

                                >
                                    Foto de perfil
                                </label>

                                <input onChange={handleImage} type="file" class="form-control" />
                            </div>

                            <div className="box-profile">
                                <img className="profile-img" width={"100%"} src={profile} alt="" />
                            </div>

                            <br /><br />

                            <button class="btn btn-primary mt-4" onClick={() => setStep(1)}>
                                Regresar
                            </button>

                            <button class="btn btn-primary mx-4 mt-4"
                                onClick={() => setStep(6)}
                            >
                                Siguiente
                            </button>

                        </>

                    }

                    {
                        step == 6 && <>

                            <div className="steps text-center mb-4">
                                <span>Paso {step} de 2</span>
                            </div>

                            <div class="mb-3">
                                <label for="exampleInputEmail1" class="form-label">Ubicacion</label>

                                <Map setter={clickMap} />
                            </div>





                            <button class="btn btn-primary mt-4" onClick={() => setStep(1)}>
                                Regresar
                            </button>

                            <button class="btn btn-primary mx-4 mt-4"
                                onClick={registerProfessional}
                            >
                                Registrar
                            </button>

                        </>

                    }


                </form>
            </div>
        </div>
    );
}